import React from 'react';
import { HiOutlinePaperClip } from 'react-icons/hi';
import { fileIcon, formatSize } from './InlineAttachments';
import { filePublicUrl } from '../../services/api';

// Renders a ticket's LEGACY flat attachment list (files uploaded before
// per-message attachments existed). New uploads go on a specific message's
// own attachments instead — see InlineAttachments.jsx, rendered inline in
// the conversation composer/timeline, where the "Attach Files" action now
// lives. This component is read-only and renders nothing when the legacy
// list is empty, so a ticket created after this change shows no
// "Attachments" card at all.
const TicketAttachments = ({ attachments = [] }) => {
  if (!attachments || attachments.length === 0) return null;

  return (
    <div className="border-t pt-3">
      <h4 className="flex items-center gap-1.5 text-sm font-semibold text-gray-900 mb-2">
        <HiOutlinePaperClip className="w-4 h-4 text-gray-400" />
        Attachments ({attachments.length})
      </h4>
      <div className="space-y-1.5">
        {attachments.map((a) => {
          const Icon = fileIcon(a.mimeType);
          return (
            <a
              key={a._id || a.fileName}
              href={filePublicUrl(a.url)}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2.5 p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors"
              title={`Open ${a.originalName}`}
            >
              <span className="w-8 h-8 rounded-lg bg-white border border-gray-200 flex items-center justify-center flex-shrink-0">
                <Icon className="w-4 h-4 text-gray-500" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-xs font-medium text-gray-800 truncate">
                  {a.originalName}
                </span>
                <span className="block text-[10px] text-gray-400">
                  {[formatSize(a.size), a.uploadedByName, a.uploadedAt ? new Date(a.uploadedAt).toLocaleDateString('en-IN') : null]
                    .filter(Boolean)
                    .join(' • ')}
                </span>
              </span>
              <HiOutlinePaperClip className="w-3.5 h-3.5 text-gray-300 flex-shrink-0" />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default TicketAttachments;
